document.addEventListener("DOMContentLoaded", () => {
  const mount = document.getElementById("evoguard-root");
  if (!mount) return;

  /* -------------------------------
     SHADOW DOM HOST
  --------------------------------- */
  const host = document.createElement("div");
  host.setAttribute("id", "evog-app-host");
  mount.appendChild(host);

  const shadow = host.attachShadow({ mode: "open" });

  /* -------------------------------
     MAIN HTML + CSS
  --------------------------------- */
  shadow.innerHTML = `
  <style>
    :host {
      font-family:-apple-system,BlinkMacSystemFont,"Helvetica Neue",Arial,sans-serif;
      display:block;
    }

    .evog-container {
      padding:20px;
      background:#f5f7f8;
      border-radius:8px;
    }

    .evog-grid {
      display:grid;
      grid-template-columns:repeat(4, minmax(0,1fr));
      gap:16px;
    }

    @media(max-width:1280px) {
      .evog-grid { grid-template-columns:repeat(2, minmax(0,1fr)); }
    }
    @media(max-width:768px) {
      .evog-grid { grid-template-columns:1fr; }
    }

    .evog-section{
  background:#e2e7e8;
  border-radius:6px;
  position:relative;
  padding-bottom:56px;
  min-height:340px;      /* + haut pour éviter débordement section 2 */
  box-shadow:0 1px 2px rgba(0,0,0,0.1);
  overflow:hidden;       /* empêche le texte/champs de dépasser visuellement */
}


    .evog-header {
      padding:12px 16px;
      background:#cfd4d6;
      border-radius:6px 6px 0 0;
      display:flex;
      align-items:center;
      gap:10px;
      color:#7b858a;
      font-weight:600;
    }

    .evog-section.is-active .evog-header {
      background:#0093bd;
      color:#fff;
    }

    .evog-step-circle {
      width:32px;
      height:32px;
      background:white;
      border-radius:50%;
      display:flex;
      align-items:center;
      justify-content:center;
      font-weight:700;
      color:#0093bd;
    }

    .evog-body {
      padding:16px;
      font-size:14px;
      padding-bottom:70px; /* laisse de la place pour les flèches en bas */
}
    }

    .evog-field {
      margin-bottom:14px;
    }

    .evog-label {
      font-size:13px;
      font-weight:600;
      margin-bottom:5px;
      display:block;
      color:#222;
    }

    .evog-select,
    .evog-input {
      width:100%;
      padding:9px 11px;
      border:1px solid #cdd3d6;
      border-radius:4px;
      background:#fff;
      font-size:14px;
      outline:none;
    }

    .evog-field.evog-has-error .evog-select,
    .evog-field.evog-has-error .evog-input {
      border-color:#d93025;
    }

    .evog-error {
      font-size:11px;
      color:#d93025;
      min-height:12px;
    }

    .evog-radio { 
      display:flex;
      align-items:center;
      gap:6px;
      cursor:pointer;
      margin-bottom:3px;
    }

    .evog-radio-dot {
      width:18px;
      height:18px;
      border:2px solid #c3cbd0;
      border-radius:50%;
      position:relative;
    }

    .evog-radio input { display:none; }

    .evog-radio input:checked + .evog-radio-dot::after {
      content:"";
      width:10px; height:10px;
      background:#0093bd;
      border-radius:50%;
      position:absolute;
      top:50%; left:50%;
      transform:translate(-50%, -50%);
    }

    .evog-btn {
      width:100%;
      margin-top:10px;
      padding:10px;
      border-radius:4px;
      cursor:pointer;
      border:1px solid transparent;
      text-transform:uppercase;
      font-size:13px;
      letter-spacing:.05em;
      transition:.15s ease-out;
    }

    .evog-btn-primary {
      background:#0093bd;
      border-color:#0093bd;
      color:white;
    }
    .evog-btn-primary:hover {
      background:white;color:#0093bd;
    }

    .evog-btn-secondary {
      background:white;color:#0093bd;border-color:#0093bd;
    }

    .evog-nav{
  position:absolute;
  bottom:12px;
  width:34px;height:34px;
  border:1px solid #cfd3d6;
  border-radius:50%;
  background:#fff;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:22px;
  cursor:pointer;
  z-index:2;
}

    .evog-nav-prev { left:10px; }
    .evog-nav-next { right:10px; }

    #result-box {
      background:white;
      border-radius:4px;
      padding:12px;
      font-size:14px;
      min-height:90px;
      line-height:1.4;
      color:#333;
      box-shadow:inset 0 0 0 1px #e3e4e5;
    }

    table.evog-bom {
      width:100%;
      border-collapse:collapse;
      font-size:13px;
      margin-top:10px;
    }
    table.evog-bom th,
    table.evog-bom td {
      padding:6px 4px;
      border-bottom:1px solid #cfd3d6;
    }
      /* Headers des 4 cases: même hauteur + titre centré */
.evog-header{min-height:74px;position:relative;justify-content:center;padding:12px 14px}
.evog-step-circle{position:absolute;left:14px;top:50%;transform:translateY(-50%)}
.evog-header>span:last-child{flex:1;text-align:center;margin:0 44px}

/* Empêche les champs de dépasser la carte (section 2) */
.evog-body,.evog-field{min-width:0}
.evog-select,.evog-input{
  box-sizing:border-box;
  max-width:100%;
  min-width:0;
  display:block;
}

  </style>


  <div class="evog-container">

    <div class="evog-grid">

      <!-- SECTION 1 -->
      <section class="evog-section evog-step is-active" data-step="1">
        <div class="evog-header">
          <span class="evog-step-circle">1</span>
          <span>Paramètres du réseau</span>
        </div>
        <div class="evog-body">

          <div class="evog-field" data-field="pipe">
            <label class="evog-label">Diamètre nominal du tuyau</label>
            <select class="evog-select" id="pipe">
              <option value="">Choisir</option>
              <option>1/2"</option>
              <option>5/8"</option>
              <option>3/4"</option>
              <option>7/8"</option>
              <option>1 1/8"</option>
              <option>1 3/8"</option>
              <option>1 5/8"</option>
              <option>2 1/8"</option>
              <option>2 5/8"</option>
              <option>3 1/8"</option>
              <option>3 5/8"</option>
              <option>4 1/8"</option>
              <option>5 1/8"</option>
            </select>
            <div class="evog-error"></div>
          </div>

          <div class="evog-field" data-field="insulation">
            <label class="evog-label">Épaisseur de l'isolant</label>
            <select class="evog-select" id="insulation">
              <option value="">Choisir</option>
              <option>3/8"</option>
              <option>1/2"</option>
              <option>3/4"</option>
              <option>1"</option>
              <option>1 1/2"</option>
              <option>2"</option>
              <option>2 1/2"</option>
              <option>3"</option>
              <option>3 1/2"</option>
              <option>4"</option>
            </select>
            <div class="evog-error"></div>
          </div>

          <div class="evog-field" data-field="installType">
            <label class="evog-label">Type de configuration</label>
            <label class="evog-radio">
              <input type="radio" name="install" value="simple">
              <span class="evog-radio-dot"></span> Simple
            </label>
            <label class="evog-radio">
              <input type="radio" name="install" value="superposee">
              <span class="evog-radio-dot"></span> Superposée
            </label>
            <div class="evog-error"></div>
          </div>

        </div>
        <span class="evog-nav evog-nav-next" data-next="2">›</span>
      </section>

      <!-- SECTION 2 -->
      <section class="evog-section evog-step" data-step="2">
        <div class="evog-header">
          <span class="evog-step-circle">2</span>
          <span>Données d'installation</span>
        </div>
        <div class="evog-body">

          <div class="evog-field" data-field="length">
           <label class="evog-label">Longueur totale de la conduite</label>
<input class="evog-input" id="length" placeholder="ex: 50">
<div class="evog-error"></div>

          </div>

          <div class="evog-field" data-field="spacing">
            <label class="evog-label">Espacement entre supports</label>
            <input class="evog-input" id="spacing" placeholder="ex: 5">
            <div class="evog-error"></div>
          </div>

          <button id="btn-calc" class="evog-btn evog-btn-primary">GÉNÉRER LES RÉSULTATS</button>

        </div>
        <span class="evog-nav evog-nav-prev" data-prev="1">‹</span>
        <span class="evog-nav evog-nav-next" data-next="3">›</span>
      </section>

      <!-- SECTION 3 -->
      <section class="evog-section evog-step" data-step="3">
        <div class="evog-header">
          <span class="evog-step-circle">3</span>
          <span>Nomenclature des produits recommandés</span>
        </div>
        <div class="evog-body">

          <div id="result-box">Aucun calcul effectué.</div>

          <button id="btn-add-bom" class="evog-btn evog-btn-primary" disabled>
            Ajouter au sommaire final
          </button>
          <button id="btn-reset" class="evog-btn evog-btn-secondary">
            Recommencer
          </button>

        </div>
        <span class="evog-nav evog-nav-prev" data-prev="2">‹</span>
        <span class="evog-nav evog-nav-next" data-next="4">›</span>
      </section>

      <!-- SECTION 4 -->
      <section class="evog-section evog-step" data-step="4">
        <div class="evog-header">
          <span class="evog-step-circle">4</span>
          <span>Sommaire consolidé du matériel</span>
        </div>
        <div class="evog-body">

          <table class="evog-bom">
            <thead><tr><th>Produit</th><th>Qté</th></tr></thead>
            <tbody id="bom-body"></tbody>
          </table>

          <button id="btn-download" class="evog-btn evog-btn-primary" disabled>
            Télécharger BOM
          </button>

          <button id="btn-clear" class="evog-btn evog-btn-secondary" disabled>
            Effacer BOM
          </button>

        </div>
        <span class="evog-nav evog-nav-prev" data-prev="3">‹</span>
      </section>

    </div>
  </div>
  `;

  /* ------------------------------------------
     JS LOGIC — CALCUL + NAVIGATION + BOM
  ------------------------------------------- */

  const steps = shadow.querySelectorAll(".evog-step");

  const pipeSel = shadow.getElementById("pipe");
  const insSel = shadow.getElementById("insulation");
  const radios = shadow.querySelectorAll("input[name='install']");
  const lengthInput = shadow.getElementById("length");
  const spacingInput = shadow.getElementById("spacing");

  const btnCalc = shadow.getElementById("btn-calc");
  const btnAdd = shadow.getElementById("btn-add-bom");
  const btnReset = shadow.getElementById("btn-reset");
  const btnDownload = shadow.getElementById("btn-download");
  const btnClear = shadow.getElementById("btn-clear");

  const resultBox = shadow.getElementById("result-box");
  const bomBody = shadow.getElementById("bom-body");

  let currentResult = null;
  let BOM = {};

  const setStep = (n) => {
    steps.forEach(s => {
      s.classList.toggle("is-active", parseInt(s.dataset.step,10) === n);
    });
  };

  shadow.querySelectorAll(".evog-nav-next").forEach(btn=>{
    btn.addEventListener("click",()=>{
      setStep(parseInt(btn.dataset.next,10));
    });
  });

  shadow.querySelectorAll(".evog-nav-prev").forEach(btn=>{
    btn.addEventListener("click",()=>{
      setStep(parseInt(btn.dataset.prev,10));
    });
  });

  const error = (field, msg) => {
    const f = shadow.querySelector(`[data-field="${field}"]`);
    f.classList.add("evog-has-error");
    f.querySelector(".evog-error").textContent = msg;
  };

  const clearErrors = () => {
    shadow.querySelectorAll(".evog-field").forEach(f=>{
      f.classList.remove("evog-has-error");
      f.querySelector(".evog-error").textContent="";
    });
  };

  const parseInches = (raw)=>{
    raw = String(raw).replace(/"/g,"");
    let total=0;
    raw.split(" ").forEach(part=>{
      if(part.includes("/")){
        let [a,b]=part.split("/");
        total+=parseFloat(a)/parseFloat(b);
      } else total+=parseFloat(part);
    });
    return total;
  };

  const findProduct = (pipeRaw, insRaw)=>{
    const ranges=[
      {n:"Evoguard® 2",min:1.25,max:2.125},
      {n:"Evoguard® 3",min:2.25,max:3.125},
      {n:"Evoguard® 4",min:3.375,max:4.125},
      {n:"Evoguard® 5",min:4.375,max:5.125},
      {n:"Evoguard® 6",min:5.375,max:6.125},
      {n:"Evoguard® 8",min:6.375,max:8.125}
    ];
    const pipe=parseInches(pipeRaw);
    const ins=parseInches(insRaw);
    const outer = pipe + 2*ins;
    const match=ranges.find(r=>outer>=r.min && outer<=r.max);
    return match ? {name:match.n, outer} : null;
  };

  /* ------------------------------------------------------------
     LOGO POUR LE BOM IMPRIMÉ (monogramme Evoguard intégré)
  ------------------------------------------------------------- */
  const LOGO_URL = "data:image/png;base64,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";

  /* ------------------------------------------------------------
     NUMÉROS DE PIÈCES (fichier PART du créateur)
     SUPPORTS     : Evoguard Slide ES250 à ES850
     ADAPTATEURS  : EB250 à EB550 (configuration superposée)
     Il n'existe pas d'adaptateur pour les formats 6 et 8 :
     le superposé est alors refusé avec un message.
  ------------------------------------------------------------- */
  const SUPPORTS = {
    "Evoguard® 2": { name: "Evoguard® 2", part: "ES250" },
    "Evoguard® 3": { name: "Evoguard® 3", part: "ES350" },
    "Evoguard® 4": { name: "Evoguard® 4", part: "ES450" },
    "Evoguard® 5": { name: "Evoguard® 5", part: "ES550" },
    "Evoguard® 6": { name: "Evoguard® 6", part: "ES650" },
    "Evoguard® 8": { name: "Evoguard® 8", part: "ES850" }
  };

  const ADAPTATEURS = {
    "Evoguard® 2": { name: "Adaptateur de superposition", part: "EB250" },
    "Evoguard® 3": { name: "Adaptateur de superposition", part: "EB350" },
    "Evoguard® 4": { name: "Adaptateur de superposition", part: "EB450" },
    "Evoguard® 5": { name: "Adaptateur de superposition", part: "EB550" }
  };

  /* Nombre d'adaptateurs par support en mode superposé */
  const ADAPTATEURS_PAR_SUPPORT = 1;

  /* Historique des calculs ajoutés au sommaire (pour le détail du BOM) */
  let CALCULS = [];

  btnCalc.addEventListener("click",()=>{
    clearErrors();

    if(!pipeSel.value) return error("pipe","Obligatoire");
    if(!insSel.value) return error("insulation","Obligatoire");

    const install=[...radios].find(r=>r.checked);
    if(!install) return error("installType","Obligatoire");

    const L=parseFloat(lengthInput.value);
    const S=parseFloat(spacingInput.value);
    if(!(L>0)) return error("length","Invalide");
    if(!(S>0)) return error("spacing","Invalide");

    const prod=findProduct(pipeSel.value,insSel.value);
    if(!prod){
      resultBox.textContent="Aucun produit compatible.";
      currentResult=null;
      btnAdd.disabled=true;
      return;
    }

    let qty=Math.floor(L/S)-1;
    if(qty<1) qty=1;

    /* Liste des articles du calcul :
       - Simple     : le support Evoguard seulement
       - Superposée : le support Evoguard + l'adaptateur par-dessus
         (la quantité de supports n'est plus doublée) */
    const isSuperposee = install.value==="superposee";
    const support = SUPPORTS[prod.name] || { name: prod.name, part: "" };
    const items=[{ name: support.name, part: support.part, qty }];

    if(isSuperposee){
      const adaptateur = ADAPTATEURS[prod.name];
      if(!adaptateur){
        resultBox.innerHTML=`
          <div style="font-weight:700;">${prod.name} : configuration superposée non disponible.</div>
          <div>Aucun adaptateur n'existe pour ce format. Choisissez la configuration simple.</div>
        `;
        currentResult=null;
        btnAdd.disabled=true;
        return;
      }
      items.push({ name: adaptateur.name, part: adaptateur.part, qty: qty*ADAPTATEURS_PAR_SUPPORT });
    }

    currentResult={
      items,
      pipe: pipeSel.value,
      insulation: insSel.value,
      type: isSuperposee ? "Superposée" : "Simple",
      length: L,
      spacing: S
    };

    resultBox.innerHTML=`
      ${items.map(it=>`<div style="font-size:16px;font-weight:700;">${it.qty}x ${it.name} <span style="font-weight:400;color:#666;">(${it.part})</span></div>`).join("")}
      <div style="margin-top:6px;">Type : ${currentResult.type}</div>
      ${isSuperposee ? `<div style="font-size:12px;color:#666;margin-top:4px;">Le support du tuyau installé par-dessus n'est pas inclus : faites un calcul séparé selon son diamètre.</div>` : ""}
      <div>Diamètre ext. ~ ${prod.outer.toFixed(2)}"</div>
    `;

    btnAdd.disabled=false;
  });

  btnAdd.addEventListener("click",()=>{
    if(!currentResult) return;
    currentResult.items.forEach(it=>{
      const key = it.part || it.name;
      if(!BOM[key]) BOM[key] = { name: it.name, part: it.part, qty: 0 };
      BOM[key].qty += it.qty;
    });
    CALCULS.push(currentResult);
    renderBOM();
    btnDownload.disabled=false;
    btnClear.disabled=false;
  });

  const renderBOM=()=>{
    bomBody.innerHTML="";
    Object.values(BOM).forEach(b=>{
      const tr=document.createElement("tr");
      tr.innerHTML=`<td>${b.name}<br><span style="font-size:11px;color:#666;">${b.part}</span></td><td>${b.qty}</td>`;
      bomBody.appendChild(tr);
    });
  };

  btnClear.addEventListener("click",()=>{
    BOM={};
    CALCULS=[];
    renderBOM();
    btnDownload.disabled=true;
    btnClear.disabled=true;
  });

  btnReset.addEventListener("click",()=>{
    pipeSel.value="";
    insSel.value="";
    radios.forEach(r=>r.checked=false);
    lengthInput.value="";
    spacingInput.value="";
    clearErrors();
    resultBox.textContent="Aucun calcul effectué.";
    currentResult=null;
    btnAdd.disabled=true;
    setStep(1);
  });

  /* ------------------------------------------
     DOCUMENT BOM IMPRIMABLE / PDF
  ------------------------------------------- */
  btnDownload.addEventListener("click",()=>{
    const now = new Date();
    const dateStr = now.toLocaleDateString("fr-CA",{year:"numeric",month:"long",day:"numeric"});
    const fileDate = now.toISOString().slice(0,10);
    const lignes = Object.values(BOM);
    const total = lignes.reduce((t,b)=>t+b.qty,0);

    const logoHtml = `<div class="brand">
        ${LOGO_URL ? `<img src="${LOGO_URL}" alt="Evoguard" class="logo">` : ""}
        <div class="logo-text">EVOGUARD<sup>®</sup></div>
      </div>`;

    const lignesHtml = lignes.map(b=>`
      <tr>
        <td class="part">${b.part}</td>
        <td>${b.name}</td>
        <td class="qty">${b.qty}</td>
      </tr>`).join("");

    const calculsHtml = CALCULS.map((c,i)=>`
      <tr>
        <td>${i+1}</td>
        <td>${c.pipe}</td>
        <td>${c.insulation}</td>
        <td>${c.type}</td>
        <td>${c.length}</td>
        <td>${c.spacing}</td>
        <td>${c.items.map(it=>`${it.qty}x ${it.part}`).join(" + ")}</td>
      </tr>`).join("");

    const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="utf-8">
<title>BOM-Evoguard-${fileDate}</title>
<style>
  @page { size: letter; margin: 18mm 16mm; }
  * { box-sizing: border-box; }
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif;
    color: #222; margin: 0; padding: 24px; font-size: 13px;
    -webkit-print-color-adjust: exact; print-color-adjust: exact;
  }
  .header {
    display: flex; justify-content: space-between; align-items: center;
    border-bottom: 3px solid #0093bd; padding-bottom: 14px; margin-bottom: 22px;
  }
  .brand { display: flex; align-items: center; gap: 14px; }
  .logo { height: 56px; width: auto; }
  .logo-text { font-size: 28px; font-weight: 800; letter-spacing: .08em; color: #0093bd; }
  .logo-text sup { font-size: 13px; }
  .doc-info { text-align: right; }
  .doc-info h1 { margin: 0 0 4px; font-size: 18px; text-transform: uppercase; letter-spacing: .06em; }
  .doc-info div { color: #666; font-size: 12px; }
  h2 {
    font-size: 13px; text-transform: uppercase; letter-spacing: .08em;
    color: #0093bd; margin: 26px 0 8px;
  }
  table { width: 100%; border-collapse: collapse; }
  th {
    background: #0093bd; color: #fff; text-align: left;
    font-size: 11px; text-transform: uppercase; letter-spacing: .05em; padding: 8px 10px;
  }
  td { padding: 8px 10px; border-bottom: 1px solid #e2e5ea; }
  tbody tr:nth-child(even) td { background: #f5f7f8; }
  td.part { font-weight: 700; white-space: nowrap; }
  td.qty, th.qty { text-align: right; width: 90px; }
  tr.total td { font-weight: 700; border-top: 2px solid #0093bd; border-bottom: none; background: #fff; }
  table.detail th { background: #e2e7e8; color: #333; }
  table.detail td { font-size: 12px; }
  .note {
    margin-top: 28px; padding: 12px 14px; background: #f5f7f8;
    border-left: 3px solid #0093bd; font-size: 11px; color: #555; line-height: 1.5;
  }
  .footer { margin-top: 24px; text-align: center; font-size: 10px; color: #999; }
</style>
</head>
<body>
  <div class="header">
    ${logoHtml}
    <div class="doc-info">
      <h1>Nomenclature du matériel</h1>
      <div>Bill of Materials (BOM)</div>
      <div>Date : ${dateStr}</div>
    </div>
  </div>

  <h2>Sommaire du matériel</h2>
  <table>
    <thead>
      <tr><th>N° de pièce</th><th>Description</th><th class="qty">Quantité</th></tr>
    </thead>
    <tbody>
      ${lignesHtml}
      <tr class="total"><td></td><td>Total des pièces</td><td class="qty">${total}</td></tr>
    </tbody>
  </table>

  <h2>Détail des calculs</h2>
  <table class="detail">
    <thead>
      <tr><th>#</th><th>Tuyau</th><th>Isolant</th><th>Configuration</th><th>Longueur</th><th>Espacement</th><th>Résultat</th></tr>
    </thead>
    <tbody>
      ${calculsHtml}
    </tbody>
  </table>

  <div class="note">
    Les quantités sont fournies à titre indicatif et doivent être validées selon les conditions réelles du chantier.
    En configuration superposée, le support du tuyau installé par-dessus n'est pas inclus.
  </div>

  <div class="footer">Document généré par le calculateur Evoguard® · ${dateStr}</div>
</body>
</html>`;

    const w = window.open("", "_blank");
    if(!w){
      alert("Veuillez autoriser les fenêtres contextuelles (pop-ups) pour télécharger le BOM.");
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();

    const lancerImpression = ()=>{ w.focus(); w.print(); };
    const img = w.document.querySelector("img.logo");
    if(img && !img.complete){
      img.onload = lancerImpression;
      img.onerror = lancerImpression;
    } else {
      setTimeout(lancerImpression, 300);
    }
  });

});